export const UVBasketExist = () =>
  typeof window !== "undefined" &&
  typeof window.universal_variable === "object" &&
  typeof window.universal_variable.basket === "object" &&
  Array.isArray(window.universal_variable.basket.line_items);
